module.exports = __webpack_public_path__ + "static/media/edgar.dd689ad2.svg";